import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {searchSellLimits} from './actions';
import ListView from "../common/ListView";
import {bindActionCreators} from "redux";

class SellLimitsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    searchSellLimits: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
  };

  render() {
    const {
      history, searchSellLimits,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        className: 'one-line-column',
      },
      {
        title: 'Period',
        dataIndex: 'period',
        key: 'period'
      },
      {
        title: 'Limit',
        dataIndex: 'value',
        key: 'value'
      },
      {
        title: 'Actions',
        dataIndex: 'sellLimitId',
        key: 'sellLimitId',
        className: 'one-line-column',
        render: (id) => {
          const encodedId = encodeURIComponent(id);
          return (
            <React.Fragment>
              <Link to={`/sell-limit/${encodedId}/edit`}>Edit</Link>
              {' | '}
              <Link to={`/sell-limit/${encodedId}/delete`}>Delete</Link>
            </React.Fragment>
          );
        },
      }
    ];
    return (
      <ListView
        title="Sell Limits"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchSellLimits}
        rowKey={row => `${row.sellLimitId}-${row.limitId}`}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/sell-limit/add')}
      />
    );
  }
}

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.sellLimit.search,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchSellLimits,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SellLimitsPage);



// WEBPACK FOOTER //
// ./src/SellLimit/SellLimitsPage.js